import React from "react";
// reactstrap components
import { Button, Card, Col, Row } from "reactstrap";
import { ScrollCard } from "./ScrollCard";

interface ScrollCardProps {
  items: ScrollCardItem[];
  seeAllCb: () => void;
  loading: boolean;
}
export interface ScrollCardItem {
  title: string;
  subtitle?: string;
  image: string;
  url: string;
}
interface ScrollCardState {
  loading: boolean;
  advVis: boolean;
  cardMH: number;
  cardMW: number;
}

export default class ScrollCards extends React.Component<ScrollCardProps, ScrollCardState> {
  private references: React.RefObject<any>[] = [];

  private bsRowMarg = 15;

  private scrollRef = React.createRef<any>();

  private seeAllRef = React.createRef<any>();

  constructor(props: any) {
    super(props);
    if (props.items) {
      props.items.forEach(() => {
        this.references.push(React.createRef());
      });
    }

    this.state = {
      loading: false,
      advVis: true,
      cardMW: 330,
      cardMH: 330,
    };
    this.advance = this.advance.bind(this);
    this.scroll = this.scroll.bind(this);
    this.setCardMW = this.setCardMW.bind(this);
  }

  public componentDidMount() {
    this.setCardMW();
    if (typeof window !== "undefined") {
      window.addEventListener("resize", this.setCardMW);
    }
  }

  public componentWillUnmount() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.setCardMW);
    }
  }

  public setCardMW() {
    if (!this.scrollRef.current) {
      return;
    }
    let ww = 0;
    if (typeof window !== "undefined") {
      ww = window.innerWidth;
    }
    const scroll = this.scrollRef.current.getBoundingClientRect();
    // the width of the scroll component + the bootstrap row margins
    const width = scroll.right - scroll.left; // + (this.bsRowMarg * 2);
    // set the card width to X across
    let cols = 2;
    if (ww <= 767) {
      cols = 1.1;
    } else if (ww >= 768 && ww <= 992) {
      cols = 1.8;
    } else if (ww >= 993 && ww <= 1399) {
      cols = 2.5;
    } else if (ww >= 1400) {
      cols = 3.1;
    }
    const calc = width / cols - this.bsRowMarg * 2;
    this.setState({
      cardMW: calc,
      cardMH: calc,
    });
  }

  public advance() {
    const nextEl = this.references.findIndex((r) => {
      const isVisible = this.isScrolledIntoView(r.current);
      return !isVisible;
    });
    if (nextEl >= 0 && nextEl < this.references.length) {
      this.references[nextEl].current.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" });
    } else {
      // scroll to the see all
      this.seeAllRef.current.scrollIntoView({ behavior: "smooth", block: "nearest" });
      this.setState({
        advVis: false,
      });
    }
  }

  public isScrolledIntoView(el: any) {
    const card = el.getBoundingClientRect();
    const scroll = this.scrollRef.current.getBoundingClientRect();
    const elemLeft = card.left;
    // Only completely visible elements return true:
    const isVisible = elemLeft <= scroll.right;
    // Partially visible elements return true:
    // isVisible = elemTop < window.innerHeight && elemBottom >= 0;
    return isVisible;
  }

  public scroll() {
    this.setState({
      advVis: !this.isScrolledIntoView(this.seeAllRef.current),
    });
  }

  public render() {
    return (
      <div className="scroller position-relative" ref={this.scrollRef}>
        <Row className="flex-row flex-nowrap h-cards " onScroll={this.scroll}>
          {" "}
          {this.props.items.map((item: ScrollCardItem, i: number) => {
            return (
              <div ref={this.references[i]} key={i} className="col">
                <ScrollCard
                  cardMH={this.state.cardMH}
                  cardMW={this.state.cardMW}
                  title={item.title}
                  subtitle={item.subtitle}
                  link={item.url}
                  imageUrl={item.image}
                />
              </div>
            );
          })}
          <Col>
            <div ref={this.seeAllRef} className="col d-flex h-100 align-items-center">
              {this.props.loading === false && (
                <div onClick={this.props.seeAllCb}>
                  <Card className="card pcard card-block h-100" style={{ minWidth: `${this.state.cardMW / 2}px` }}>
                    <div className="text-center">
                      <Button color="secondary">See All</Button>
                    </div>
                  </Card>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}
